import { Colors } from 'basic-ui-lib';
import styled from 'styled-components';
import StoreInfoPanel from './component/StoreInfoPanel';
import StoreScreenTable from './component/ListScreen';
import { useMediaQuery } from 'react-responsive';
import DetailStoreMobile from './DetailStoreMobile';

const StoreDetailPage = () => {
  const isMobile = useMediaQuery({maxWidth: 768});

  if (isMobile) {
    return <DetailStoreMobile />;
  }
  
  return (
    <Container>
      <LeftSection>
        <StoreInfoPanel />
      </LeftSection>
      <RightSection>
        <StoreScreenTable />
      </RightSection>
    </Container>
  );
};

export default StoreDetailPage;

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

const LeftSection = styled.div`
  width: 300px;
  overflow-y: auto;
  background-color: ${Colors.neutral.bg[1]};
  border-right: 1px solid ${Colors.neutral.border[1]};
`;

const RightSection = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 8px;
`;
